// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shipment-section[data-v-6a53cf8c]{margin-top:75px}@media(max-width:599px){.shipment-section[data-v-6a53cf8c]{padding-bottom:60px}}", ""]);
// Exports
module.exports = exports;
